export default __webpack_public_path__ + "static/patio-v4-5-84633a44babdcf52aa57cb4b95082897.jpg";